import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Card, { CardFooter, CardTitle } from '../../Cards/Card';

var Course = /*#__PURE__*/function (_Component) {
  _inherits(Course, _Component);

  var _super = _createSuper(Course);

  function Course(props) {
    var _this;

    _classCallCheck(this, Course);

    _this = _super.call(this, props);
    _this.state = {
      color: _this.props.course.hasOwnProperty('colorCode') ? _this.props.course.colorCode : ''
    };
    return _this;
  }

  _createClass(Course, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Card, {
        type: "course",
        id: this.props.course.id,
        color: this.state.color,
        target: "/Course/".concat(this.props.course.id)
      }, /*#__PURE__*/React.createElement(CardTitle, null, this.props.course.title), /*#__PURE__*/React.createElement(CardFooter, null));
    }
  }]);

  return Course;
}(Component);

export { Course as default };